import { EAvailableLanguages, ELanguageDisplayName } from '@/configuration/lang/types';

const LANGUAGE_CODE_MAP: Record<string, EAvailableLanguages> = {
  de: EAvailableLanguages.DE,
  fr: EAvailableLanguages.FR,
  en: EAvailableLanguages.EN,
};

const LANGUAGE_DISPLAY_NAME_MAP: Record<EAvailableLanguages, ELanguageDisplayName> = {
  [EAvailableLanguages.DE]: ELanguageDisplayName.DE,
  [EAvailableLanguages.FR]: ELanguageDisplayName.FR,
  [EAvailableLanguages.EN]: ELanguageDisplayName.EN,
};

/**
 * Maps a language code string to the corresponding EAvailableLanguages enum value.
 * Supports both ISO 639-1 codes ('de') and full BCP-47 locales ('de-DE').
 * Falls back to English if the provided code is not recognized.
 *
 * @param code - Language code (e.g. 'de', 'fr', 'en-GB', 'de-DE')
 * @returns The matching EAvailableLanguages value, or EAvailableLanguages.EN as default
 */
export const toAvailableLanguagesMapper = (code: string): EAvailableLanguages => {
  const normalizedCode = code.split('-')[0].toLowerCase();

  if (normalizedCode in LANGUAGE_CODE_MAP) {
    return LANGUAGE_CODE_MAP[normalizedCode];
  }

  return EAvailableLanguages.EN;
};

/**
 * Maps an EAvailableLanguages enum value to its human-readable display name.
 *
 * @param language - The EAvailableLanguages enum value
 * @returns The corresponding ELanguageDisplayName value
 */
export const toLanguageDisplayName = (language: EAvailableLanguages): ELanguageDisplayName => {
  return LANGUAGE_DISPLAY_NAME_MAP[language];
};
